import { render } from "./CombineRooms.vue?vue&type=template&id=517a5d42"
import script from "./CombineRooms.vue?vue&type=script&lang=js"
export * from "./CombineRooms.vue?vue&type=script&lang=js"

import exportComponent from "/var/www/greenified-mono-staging/ims.greenified.se/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__